/* __next_internal_client_entry_do_not_use__ default auto */ import { jsx as _jsx } from "react/jsx-runtime";
import { useParams, useRouter } from "next/navigation";
import ManageProduct from "../components/ManageProduct";
import ConfirmationModal from "../../components/ConfirmationModal";
import useSubscriptionStore from "../../store/subscriptionStore";
import { useTranslation } from "../../../../i18n/client";
import { useFetchCompanyDetails } from "../../../../../data/fetch-hooks";
export default function AddNewProductPage() {
    var _companyDetails_companyDetails_companyDetailRecord, _companyDetails_companyDetails;
    const router = useRouter();
    const params = useParams();
    const { t } = useTranslation(params === null || params === void 0 ? void 0 : params.lng, "products");
    const isCompanyDetailsCompleted = useSubscriptionStore((state)=>state.isCompanyDetailsCompleted);
    const { data: companyDetails = {}, isLoading } = useFetchCompanyDetails();
    const companyDetailsComplete = companyDetails === null || companyDetails === void 0 ? void 0 : (_companyDetails_companyDetails = companyDetails.companyDetails) === null || _companyDetails_companyDetails === void 0 ? void 0 : (_companyDetails_companyDetails_companyDetailRecord = _companyDetails_companyDetails.companyDetailRecord) === null || _companyDetails_companyDetails_companyDetailRecord === void 0 ? void 0 : _companyDetails_companyDetails_companyDetailRecord.is_complete;
    if (isCompanyDetailsCompleted || companyDetailsComplete === true) {
        return /*#__PURE__*/ _jsx(ManageProduct, {});
    }
    if (isLoading || companyDetailsComplete === undefined) {
        return null;
    }
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        open: true,
        handleClose: ()=>router.push("/application/products"),
        title: t("account_setup_required_title"),
        subtitle: t("account_setup_required_subtitle"),
        primaryBtnName: t("account_setup_create_account"),
        primaryBtnAction: ()=>router.push("/application/myaccount"),
        secondaryBtnName: t("account_setup_cancel"),
        secondaryBtnAction: ()=>router.push("/application/products")
    });
}
